// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useEffect } from "react";
import { Link, navigate } from "@reach/router";
import { RouteComponentProps } from "@reach/router";
import { Button, Layout, Divider } from "antd";
import PageHeader from "../../components/PageHeader";
import PageBody from "../../components/PageBody";
import PageTitle from "../../components/PageTitle";
import { useTranslation } from "react-i18next";
import { authentifiedUserEvent, logout } from "../../../state/auth/AuthEvents";
import configuration from "../../../utils/Config";
import { requestGetUserInfo } from "../../../state/auth/AuthEffects";
import logger from "../../../utils/logger";

const ForcedLogOutView: React.FunctionComponent<RouteComponentProps> = () => {
  const { t } = useTranslation();
  const loginUrl = `${configuration.backendBaseUrl}/auth/login?redirect_uri=${configuration.postLoginUrl}`;
  useEffect(() => {
    requestGetUserInfo.done.watch(({ result }) => {
      if (!!result.data) {
        logger.debug(
          "ForcedLogOutView called but user is authentified => home"
        );
        authentifiedUserEvent(result.data);
        navigate("/");
      } else {
        logout();
      }
    });
  }, []);
  return (
    <>
      <Layout style={{ height: "100vh" }} className="content-container">
        <Layout.Content className="content">
          <PageHeader>
            <PageTitle title={t("dashboard.title")} />
          </PageHeader>

          <PageBody>
            <div className="text-center">{t("auth.forcedLogOut")}</div>
            <Divider />
            <div className="text-center">
              <Button type="default" className="btn-secondary">
                <Link
                  to=""
                  onClick={() => {
                    window.location.href = loginUrl;
                  }}
                >
                  {t("auth.loginAgain")}
                </Link>
              </Button>
            </div>
          </PageBody>
        </Layout.Content>
      </Layout>
    </>
  );
};

export default ForcedLogOutView;
